module.exports = __webpack_public_path__ + "static/media/gwarancja.9e787f33.svg";